import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {MapService} from '../../core/map/map.service';

@Component({
  selector: 'app-layers',
  templateUrl: './layers.component.html',
  styleUrls: ['./layers.component.scss']
})
export class LayersComponent implements OnInit {

  @Output() close = new EventEmitter();

  constructor(public map: MapService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./client/app/components/layers/layers.component.ts